export enum WireCoverageRefId {
  COMP = 'COMP',
  COMPG = 'COMPG',
  TPPD = 'TPPD',
  TPFT = 'TPFT',
  Contents = 'Contents',
  HomenCon = 'HomeNCon',
  Home = 'Home',
}

export enum WireCoverType {
  Comprehensive = 'Comprehensive',
  ComprehensivePlus = 'ComprehensivePlus',
  ThirdPartyFireAndTheft = 'ThirdPartyFireAndTheft',
  ThirdPartyPropertyDamage = 'ThirdPartyPropertyDamage',
  Building = 'Building',
  BuildingAndContents = 'BuildingAndContents',
  Contents = 'Contents',
  Unspecified = '',
}

export enum WireCoverageOptionType {
  WindScreen = 'WindScreen',
  HireCar = 'HireCar',
  FreqLoad = 'FreqLoad',
  RoadSide = 'RoadSide',
  NCBProtected = 'NCBProtected',
  NoClaimProtect = 'NoClaimProtect',
  Building = 'Building',
  FusionBuilding = 'FusionBuilding',
  FusionCoverBuilding = 'FusionCoverBuilding',
  FusionContent = 'FusionContent',
  StormwaterBuilding = 'StormwaterBuilding',
  MABuilding = 'MABuilding',
  Content = 'Content',
  FusionCoverContent = 'FusionCoverContent',
  StormwaterContent = 'StormwaterContent',
  MAContent = 'MAContent',
  GeneralPortables = 'GeneralPortables',
  SpecifiedPortables = 'SpecifiedPortables',
  FloodBuilding = 'FloodBuilding',
  FloodContent = 'FloodContent',
  Under25 = 'Under25',
  AccidentalDamage = 'AccidentalDamage',
  TenantDamage = 'TenantDamage',
  Unspecified = '',
}

export enum WireCoverageType {
  Standard = 'Standard',
  Optional = 'Optional',
}

export type WireCoverageOption = {
  name: string;
  value: boolean;
};

export type WireCoverageBase = {
  id: string;
  name: WireCoverType;
  type: WireCoverageType;
};

export enum WireItemType {
  SpecifiedPortables = 'SpecifiedPortables',
  GeneralPortables = 'GeneralPortables',
  Contents = 'Contents',
  Building = 'Building',
  Discount = 'Discount',
}

export enum WireCoverageOptionalExtraId {
  FusionCoverContent = 'FusionCoverContent',
  FusionCoverBuilding = 'FusionCoverBuilding',
  AccidentalDamage = 'AccidentalDamage',
  GeneralPortables = 'GeneralPortables',
}
